<template>
    <div class="relative">
        <nav
             aria-label="Tabs"
             class="flex items-end gap-16 w-full"
             :class="{'overflow-x-scroll': scroll}"
        >
            <div v-for="(item, index) in items" class="z-10 transition group">
                <button
                    :class="[item.disabled ? disabledButtonClass : (activeKey === index ? enabledButtonClass : defaultButtonClass)]"
                    class="flex items-center gap-8 py-8 px-16"
                    :disabled="item.disabled || false"
                    :key="index + '-inline'"
                    @click="setActive(index)"
                >
                    <svg-icon
                        v-if="item.icon"
                        :type="item.icon"
                        class="w-24 h-24"
                        :class="item.iconColor"
                    />
                    <span class="flex items-center gap-8">
                        <span
                            class="capitalize font-semibold"
                            :class="titleSize"
                        >
                            {{ item.title }}
                        </span>

                        <tooltip
                            v-if="errors && errors.includes(index)"
                            position="top"
                            without-arrow
                        >
                            <template #default>
                                <svg-icon class="text-semantic-warning w-18 h-18"
                                          type="warning">
                                </svg-icon>
                            </template>
                            <template #tooltip>
                                <div class="whitespace-nowrap">
                                    <span>{{ $t('general.missing_translation') }}</span>
                                </div>
                            </template>
                        </tooltip>
                    </span>

                    <simple-dropdown
                        v-if="item.settings && $slots.settings"
                        :class="activeKey === index ? 'text-primary' : 'text-primary-40'"
                    >
                        <template #trigger>
                            <button
                                class="text-primary hover:text-primary-80 rounded"
                                role="button"
                            >
                                <svg-icon class="w-24 h-24" type="more-vert"/>
                            </button>
                        </template>
                        <template #content="{ close }">
                            <div aria-labelledby="option-menu"
                                 aria-orientation="vertical"
                                 class="bg-white relative rounded shadow-md p-8 space-y-8 z-top"
                                 role="menu"
                            >
                                <slot name="settings"></slot>
                            </div>
                        </template>
                    </simple-dropdown>

                    <template v-if="$slots.after">
                        <slot name="after"></slot>
                    </template>

                    <badge v-if="item.count" :display="item.badge" :content="item.count"/>
                </button>
            </div>
            <div v-if="!card" class="absolute bottom-0 border-b border-primary-20 w-full"></div>
        </nav>
    </div>
</template>

<script>
import SvgIcon from '../ui/SvgIcon.vue';
import Tooltip from './Tooltip.vue';
import SimpleDropdown from '../ui/SimpleDropdown.vue';
import Badge from "../ui/Badge.vue";

export default {
    components: {
        Badge,
        SimpleDropdown,
        Tooltip,
        'svg-icon': SvgIcon,
    },
    props: {
        card: Boolean,
        items: {
            type: [Object, Array],
        },
        activeKey: null,
        errors: Array,
        scroll: Boolean,
        size: {
            type: String,
            default: 'md',
            validator: (value) => ['md', 'lg'].includes(value),
        },
    },
    data: function () {
        return {
            enabledButtonClasses: {
                card: 'bg-white text-secondary rounded-t',
                default: 'text-secondary hover:text-primary rounded-t border-b border-secondary hover:border-primary'
            },
            defaultButtonClasses: {
                card: 'bg-primary-20 text-primary-80 hover:text-primary hover:underline hover:bg-primary-40 rounded-t',
                default: 'text-primary-80 hover:text-primary rounded-t border-b border-primary-20 hover:border-primary',
            },
            disabledButtonClasses: {
                card: 'bg-primary-20 text-primary-40 cursor-not-allowed rounded-t',
                default: 'text-primary-40 cursor-not-allowed rounded-t border-b border-primary-20',
            }
        };
    },
    computed: {
        //text-primary - needed for purge css
        //text-primary - needed for purge css
        //text-v-500 - needed for purge css
        //border-primary-80 - needed for purge css
        //bg-primary-20 - needed for purge css
        // space-x-28 - needed for purge css
        enabledButtonClass() {
            return this.enabledButtonClasses[this.card ? 'card' : 'default'];
        },
        defaultButtonClass() {
            return this.defaultButtonClasses[this.card ? 'card' : 'default'];
        },
        disabledButtonClass() {
            return this.disabledButtonClasses[this.card ? 'card' : 'default'];
        },
        titleSize() {
            return this.size === 'lg' ? 'text-body' : 'text-body-sm';
        }
    },
    methods: {
        setActive(item) {
            this.$emit('set-active', item);
        },
    },
};
</script>

<style scoped>

</style>
